const escapeCsvCell = (value: unknown): string => {
  const source = value === null || value === undefined ? '' : String(value);
  // Spreadsheet programs treat these prefixes as formulas. Applicant-provided
  // names/messages must remain plain data when an employer opens the export.
  const text = /^[=+\-@]/.test(source) ? `'${source}` : source;
  if (!/[",\r\n]/.test(text)) return text;
  return `"${text.replace(/"/g, '""')}"`;
};

export const rowsToCsv = (rows: unknown[][]): string => (
  rows.map((row) => row.map(escapeCsvCell).join(',')).join('\r\n')
);

const safeFilename = (filename: string): string => {
  const normalized = filename
    .trim()
    .replace(/[^a-z0-9._-]+/gi, '-')
    .replace(/^-+|-+$/g, '');
  return normalized || 'export';
};

export const downloadCsv = (filename: string, rows: unknown[][]): void => {
  const blob = new Blob([`\uFEFF${rowsToCsv(rows)}`], {
    type: 'text/csv;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${safeFilename(filename)}.csv`;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
